import { useContext } from "react";
import { NotificationsContext } from "../context/notifications-context.js";

/**
 * Garante que o hook está sob NotificationsProvider.
 * @returns {{ mounted: true }}
 */
export function useNotificationsMountedGuard() {
  const context = useContext(NotificationsContext);

  if (!context?.mounted) {
    throw new Error(
      "useNotifications hooks must be used within NotificationsProvider",
    );
  }

  return context;
}
